import { CheckCircle2 } from "lucide-react";

const POINTS = [
  "Συνεργασίες με τους μεγαλύτερους παρόχους τηλεπικοινωνιών",
  "Πλήρως εξοπλισμένα συνεργεία πεδίου",
  "Πιστοποιημένοι τερματισμοί & μετρήσεις OTDR",
  "Άμεση ανταπόκριση σε αναφορές βλάβης",
  "Έδρα στους Αγίους Αναργύρους — κάλυψη Αττικής",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 sm:py-32 bg-[#0F0F11] border-y border-[#27272A]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-12 gap-10 lg:gap-16">
          <div className="col-span-12 lg:col-span-5">
            <div className="overline mb-4">02 / Εταιρεία</div>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white leading-tight">
              Γιατί να μας
              <br />
              <span className="text-[#E63946]">επιλέξετε.</span>
            </h2>
            <div className="mt-10 grid grid-cols-2 gap-6">
              <Metric value="15+" label="Έτη εμπειρίας στο πεδίο" />
              <Metric value="500+" label="Έργα οπτικών ινών" />
              <Metric value="100%" label="Πιστοποιημένα συνεργεία" />
            </div>
          </div>

          <div className="col-span-12 lg:col-span-7">
            <p className="text-[#A1A1AA] text-base sm:text-lg leading-relaxed">
              Με έδρα τους Αγίους Αναργύρους, η{" "}
              <span className="text-white">Technological Horizons</span>{" "}
              εγγυάται την απόλυτη αξιοπιστία στις τηλεπικοινωνιακές σας
              υποδομές. Η συνεργασία μας με τους μεγαλύτερους παρόχους αποτελεί
              την πιο ηχηρή απόδειξη της ποιότητας των έργων μας.
            </p>
            <p className="mt-5 text-[#A1A1AA] leading-relaxed">
              Η ομάδα μας απαρτίζεται από εξειδικευμένους τεχνικούς οπτικών
              ινών με πολυετή εμπειρία στην κατασκευή, στον τερματισμό και
              στην αποκατάσταση βλαβών — εντός και εκτός των εγκαταστάσεων του
              πελάτη.
            </p>

            <div className="mt-10 border border-[#27272A] divide-y divide-[#27272A]">
              {POINTS.map((p) => (
                <div
                  key={p}
                  className="flex items-start gap-4 px-5 py-4 hover:bg-[#16161A] transition-colors"
                >
                  <CheckCircle2
                    size={18}
                    className="text-[#E63946] mt-0.5 shrink-0"
                  />
                  <span className="text-sm sm:text-base text-white/90">
                    {p}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Metric({ value, label }) {
  return (
    <div className="border-l border-[#27272A] pl-4">
      <div className="font-heading text-3xl sm:text-4xl text-white font-medium tracking-tighter">
        {value}
      </div>
      <div className="mt-1 text-xs sm:text-sm text-[#A1A1AA] leading-snug">
        {label}
      </div>
    </div>
  );
}
